import React from 'react';
import { Card } from '../../../types/interfaces';
import favoriteIcon from '../assets/favorite.svg';
import favoriteActiveIcon from '../assets/favorite-active.svg';

interface AddToFavoritesButtonProps {
  item: Card;
  isFavorite?: boolean;
  onToggle?: (itemId: number) => void;
}

export function AddToFavoritesButton({ item, isFavorite = false, onToggle }: AddToFavoritesButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onToggle) {
      onToggle(item.id);
    }
  };

  return (
    <div
      onClick={handleClick}
      className="cursor-pointer hover:opacity-80 transition-all duration-300 rounded-full p-2  flex items-center justify-center bg-[#E3282A12] hover:bg-red-100"
      title={isFavorite ? 'Удалить из избранного' : 'Добавить в избранное'}
    >
      <img
        src={isFavorite ? favoriteActiveIcon : favoriteIcon}
        alt="favorite"
        className="transition-transform duration-300"
      />
    </div>
  );
}
